(ns kyber.components.composite.media-player
  (:require [reagent.core :as reagent]
            [re-frame.core :as re-frame]
            [goog.object :as gobj]

            [kyber.components.composite.videojs-player :refer [videojs-player]]
            [kyber.components.composite.resource :refer [resource]]
            [kyber.constants :refer [base-api-url]]
            [kyber.styles.core :refer [gs styles->classes]]
            [kyber.components.base.icons :as icon]

            [kyber.components.composite.media-control-bar
             :as media-control-bar]
            [kyber.components.base.text :as text]
            [kyber.i18n.core :as i18n]))

(def videojs (gobj/get js/window "videojs"))

(def classes
  (styles->classes
   {:player-container
    {:display :flex
     :position :relative}

    :video-container
    {:height "100%"}

    :audio-icon
    {:color (gs [:colors :primary-gray-800])}

    :audio-icon-margin
    {:margin-right "15px"
     :margin-left "5px"}
    
    :center-audio-text
    {:display :flex
     :flex-direction :column
     :align-items :center
     :margin-top "10px"}

    :audio-header-text
    {:display :flex
     :flex-direction :column
     :margin-top "2px"}

    :audio-header
    {:margin :auto
     :display :flex
     :flex-direction :column
     :justify-content :center
     :align-items :center
     :padding (gs [:spacing :p8])
     :width "100%"}

    :audio-header-preview
    {:margin :auto
     :display :flex
     :justify-content :flex-start
     :align-items :center
     :padding (gs [:spacing :p8])
     :border-radius (gs [:radius :r7])
     :margin-bottom (gs [:spacing :p20])
     :width "100%"
     :background-color (gs [:colors :gray-scale-100])
     :border (str "1px solid " (gs [:colors :gray-scale-300]))}}))

(defn render
  [{:keys [player-key hide-meta-data? audio-preview?]
    :or {hide-meta-data? false audio-preview? false}}]
  (let [player-state (re-frame/subscribe [:media-player/player-attributes
                                          player-key])
        token (re-frame/subscribe [:authentication/session-token])
        active-resource-key :resource-library/active-resource]
    (reagent/create-class
     {:reagent-render
      (fn [{:keys [class plo render-overlay show-controls]
            :or {show-controls false}}]
        (let [url (or (:resource/url plo)
                      (:url plo))
              m3u8 (or (:resource/m3u8 plo)
                       (:m3u8 plo))
              poster (or (:resource/poster plo)
                         (:poster plo))
              file-type (or (:resource/file-type plo)
                            (:file-type plo))
              uuid (or (:resource/uuid plo)
                       (:uuid plo))
              name (or (:resource/name plo)
                       (:name plo))
              source-map (case file-type
                           "video" {:src m3u8
                                    :type "application/x-mpegURL"}

                           "audio" {:src (str base-api-url
                                              url
                                              "?token="
                                              @token)
                                    :type "audio/mpeg"}

                           (js/console.error "Unsupported file-type '"
                                             file-type
                                             "'"))]
          [:div {:class class
                 :style (cond-> {:display :flex
                                 :flex-direction :column
                                 :justify-content :center
                                 :align-items :center
                                 :height "100%"
                                 :width "100%"
                                 :flex (when (= file-type "audio") 1)}
                          
                          audio-preview?
                          (assoc :justify-content :flex-end))}
           (when (= file-type "audio")
             (if (some? poster)
               [resource {:tag :img
                          :src poster
                          :alt name}]
               [text/title-20 :h4 name])
             (when (false? hide-meta-data?)
               [:div {:class (if audio-preview? (:audio-header-preview classes) (:audio-header classes))}
                [icon/icon-xl {:class (cond-> [(:audio-icon classes)]
                                        audio-preview?
                                        (conj (:audio-icon-margin classes)))} :file-audio]
                [:div {:class (if audio-preview? (:audio-header-text classes) (:center-audio-text classes))}
                 [text/title-20 :h4 (i18n/t* ::audio-file-header)]
                 [text/display-10 :p name]]]))

           [:div {:class (cond-> [(:player-container classes)]
                           (= file-type "video")
                           (conj (:video-container classes)))}

            (when (and (some? render-overlay) (= file-type "video"))
              [render-overlay {:player-key player-key
                               :player-state @player-state}])

            [videojs-player {:id player-key
                             :resource-uuid uuid
                             :element-tag file-type
                             :player-key player-key
                             :controls false
                             :preload "auto"
                             :crossOrigin "anonymous"
                             :sources [source-map]}
             {:active-resource-key active-resource-key}]]

           (when (true? show-controls)
             [media-control-bar/render {:player-key player-key
                                        :player-state @player-state}])]))})))
